{
  "id": "campaign-064",
  "name": "Weedy Links",
  "seed": "campaign:64",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ",,,,,,,,,,,,",
    ",,,,,,,,,,,,",
    ",,ooo,,,,,,,",
    ",,oFo,,,,,,,",
    ".sooo,,,,,,,",
    ".s.,Wss,,,,,",
    ".x.,,,s,,,,,",
    "*.h.,h,,,.#.",
    "*....,,,....",
    "*.,,,,,,....",
    "*,,,,,,,....",
    "*,h,h,h,h.h.",
    "*,,,,,,,,,,,",
    ",,,,,,,,#,..",
    ",,,,,,,,...S"
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 9,
      "y": 8
    },
    {
      "kind": "squirrel",
      "x": 3,
      "y": 8
    },
    {
      "kind": "squirrel",
      "x": 0,
      "y": 4
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 5,
      "y": 2
    },
    {
      "kind": "gas",
      "x": 10,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 13
    },
    {
      "kind": "rare",
      "x": 1,
      "y": 4
    },
    {
      "kind": "repair",
      "x": 11,
      "y": 1
    }
  ],
  "generatorVersion": 3,
  "level": 64,
  "biome": "golf",
  "par": {
    "reel": 15250,
    "push": 9021,
    "selfPropelled": 8274,
    "tractor": 4955,
    "zeroTurn": 5845,
    "fairway": 3090
  },
  "routeTries": {
    "par": {
      "reel": 10,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 0,
      "zeroTurn": 10,
      "fairway": 9
    }
  }
}
